var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('h3',[_vm._v(" Billing & payment")]),_c('h5',{staticClass:"text-gray"},[_vm._v("Prior monthly charges and payment information")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }